import { Editor, TinyMCE } from 'tinymce';
import { decodeMML, getData } from '../core/Utils';
import { loadPropItem } from '../../Loads/Loads';
import { makeEditorModal } from '../Modal';
import { transformInput } from './TransformInputs';
import { transformProp } from './TransformProps';
import { AbLoads } from '../../Viewer/LoadExam/AbLoads';
import { ajaxSpin, errorToast, getSearchParam, successToast } from '../../Utils/utils';
import { ajaxRequest } from '../../Utils/Ajax/ajax';

export function addSubmitFunction(){
    appendWrappers();
    $(".save-task").on("click", function(){
        saveTask($(this));
    });
    $(".task-preview").on("click", function(){
        previewTask();
    });
}

export interface solutionItem {
    name: string;
    type: string;
    url: string;
}

interface taskData {
    aufgabe_name: string,
    self: number,
    code: string;
    editor_code: string;
    display_code: string;
    losungen: string;
    losung_source: string;
    losung_items: Array<solutionItem>
    punkte: number;
}



function loadTaskProps(){
    MathJax.typeset();

    const props = $(".prop-load-item")
    
    props.each((ind, obj) => {
        loadPropItem(obj);
    });

}

function previewTask(){
    const editorCode = getEditorCode();
    createDisplayCode(editorCode);

    let content = '<div id="task-preview-modal">';
    content += '</div>';


    const settings = {
        size: "xl"
    }

    const aufgabeName = getAufgabeName();

    const modal = makeEditorModal("task-test", "Vorschau: " + aufgabeName, content, settings);
    const displayHtml = $("#display-code-wrapper").html();
    $("#display-code-wrapper").html("");
    $("#task-preview-modal").html(displayHtml);

    // loadTaskProps();
    AbLoads();
    MathJax.typeset()

}

function appendWrappers(){
    $(document.body).append('<div class="d-none" id="display-code-wrapper"></div><div class="d-none" id="code-wrapper"></div><div class="d-none" id="editor-code-wrapper"></div>')
}

export function createDisplayCode(editorCode):[object, Array<string>]{
    $("#display-code-wrapper").html(editorCode);

    const [solutions, types] = transformAllInputs();
    transformProps();
    transformMath(); // for new math style

    return [solutions, types]
}

function transformAllInputs(){
    const solutions = {};
    const types = [];
    const items = $("#display-code-wrapper").find(".input-item");
    
    items.each((ind, obj) => {
        const data = getData(obj);
        
        const transformed = transformInput(data, ind + 1, obj); // Object eigentlich unnötig, aber kann man vlt noch braucen
        solutions[ind] = transformed.solution
        types.push(data.type);
        $(obj).replaceWith(transformed.html);
    })
    return [solutions, types];
}

function transformProps(selector="#display-code-wrapper"){
    const props = $(selector).find(".prop-item");
    
    props.each((ind, obj) => {
        const data = getData(obj);
        const transformedHtml = transformProp(data, obj);
        $(obj).replaceWith(transformedHtml);
    })
}

function transformMath(selector='#display-code-wrapper'){
    const maths = $(selector).find("img.pexamath")
    maths.each((ind, obj) => {
        const data = obj.getAttribute("data-mathml")
        const mathml = decodeMML(data)
        $(obj).replaceWith(mathml)
    })
}

function createCode(editorCode, types:Array<string>){
    $("#code-wrapper").html(editorCode);
    
    const items = $("#code-wrapper").find(".input-item");
    items.each((ind, obj) => {
        $(obj).replaceWith("<<||" + types[ind] + "_" + (ind+1) + "||>>")
    })

    transformProps("#code-wrapper"); // here auch
    transformMath("#code-wrapper");
}


function getEditorCode(){
    const editor = tinymce.get("task-editor");
    const content = editor.getContent({format: 'html'});

    $("#editor-code-wrapper").html(content)

    transformMath("#editor-code-wrapper")

    return $("#editor-code-wrapper").html();
}


function saveTask(btn:JQuery){
    const editorCode = getEditorCode();

    const [solutions, types] = createDisplayCode(editorCode);
    createCode(editorCode, types);
    const fachNummer = getFachNummer();
    const fachId = $("#course-id").val();
    const topicId = $("#topic-id").val()
    const aufgabeName = getAufgabeName();
    const [points, self] = getTaskMetaData(solutions);
    const solutionText = getSolutionText();
    const solutionItems = getSolutionItems();
  //  const code = getCode().replaceAll("&lt;", "<").replaceAll("&gt;", ">");
    const displayCode = getDisplayCode();

    const taskId = $("#aufgabe-id").val();

    let url;
    if (window.location.pathname.startsWith('/editor/i')){
        const materialId = $("#material-id").val()
        const start = '/course/' + fachId + '/topic/' + topicId
        const end = taskId == 0 ? '/material/create' : '/material/' + materialId + '/edit'
    
        url = start + end
    } else {
        url = (taskId == 0) ? '/task/save/' + fachId.toString() : '/task/edit/' + taskId.toString();
    }

    const data = {
        //    action: "save_task_v2",
            entityType: 'task',
            courseId: fachId,
            topicId: topicId,
            courseNumber: fachNummer,
            name: aufgabeName,
            solutions: solutions,
            solutionText: solutionText,
            solutionItems: solutionItems,
            points: points,
            self: self,
    //        code: code,
            editorCode: editorCode,
            displayCode: displayCode,
    }

    const success = function (data){
        btn.prop('disabled', true);
        successToast("Aufgabe gespeichert", "Erfolg", 4500);
        console.log(data)
        setTimeout(() => {
            
           window.location = data.redirect_url
           // window.location = "/aufgaben/" + fachId.toString(); // maybe update to data.redirect_url
        }, 500);
    }
    
    return ajaxRequest(url, success, data, btn)
}

function getSolutionItems():Array<solutionItem>{
    const solItems = $(".task-answer-item");
    const solutionItems = [];
    solItems.each((ind, obj) => {
        solutionItems.push({
            name: $(obj).find(".task-file-name").html(),
            url: $(obj).attr('data-url'),
            type: $(obj).attr('data-type')
        })
    });
    return solutionItems;
}

function getSolutionText(){
    return tinymce.get("solution-editor").getContent();
}

function getCode(){
    return $("#code-wrapper").html()
}

export function getDisplayCode(){
    return $("#display-code-wrapper").html();
}

export function getTaskMetaData(solutions){
    let totalPoints = 0;
    const selfes = ["ft", "ez"]
    let self = 0;
    for (const[index, input] of Object.entries(solutions)){
        totalPoints += parseFloat(input.gewichtung);
        if (selfes.includes(input.type)){
            self = 1;
        }
    }
    return [totalPoints, self];
}

function getAufgabeName(){
    return $("#aufgabe-name").val();
}

function getFachId(){
    return getSearchParam("fach", false);
}

function getFachNummer(){
    return getSearchParam("nummer", null);
}


